import React, {useContext} from 'react';
import {Image} from 'semantic-ui-react';
import md5 from 'md5'

import UserContext from 'UserContext';

const baseUrl = 'https://www.gravatar.com/avatar/';
export default props => {
  const userContext = useContext(UserContext);
  const avatarSrc = baseUrl + md5(userContext.user, {encoding: "binary"}) + '?d=mp';
  return (<Image src={avatarSrc} avatar />);
}